/* sk8 Monster Drops, tema PS2, maleta.js.
   Dono: frente 3 (maleta). Hover e inclinacao 3D dos slots, o recorte da
   foto sob demanda (tira o chao de cimento da foto e deita a camiseta no
   feltro da maleta; se o recorte falhar, a foto fica como esta), o video
   do vendedor da colecao que so toca com ele em tela e o vendedor que fala
   ao clique, com a legenda escrita no ritmo do audio. Carrega em
   sections/maleta.liquid, templates/collection.liquid, templates/search.liquid
   e templates/product.liquid (por causa de "Voce tambem pode gostar"),
   sempre depois de base.js (usa SK8.$, SK8.$$, SK8.importar, SK8.modulos,
   SK8.voz e SK8.prepararVozes). */
(function () {
  "use strict";

  var SK8 = window.SK8 || {};
  var $ = SK8.$, $$ = SK8.$$;
  var importar = SK8.importar;

  // vendedor ao lado do catalogo (templates/collection.liquid): o video so
  // toca com ele na tela, pausa quando sai (celular rola o catalogo para
  // baixo e deixa o vendedor para tras).
  // O aviso "X Falar" tambem para de piscar com o vendedor fora da tela (.fora).
  var videos = $$("[data-video-sob-demanda]");
  if (videos.length && "IntersectionObserver" in window) {
    var obsVideo = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (e.isIntersecting) e.target.play().catch(function () {});
        else e.target.pause();
        var dono = e.target.closest(".colecao-vendedor");
        if (dono) dono.classList.toggle("fora", !e.isIntersecting);
      });
    }, { threshold: .35 });
    videos.forEach(function (v) { obsVideo.observe(v); });
  }

  /* vendedor que fala (templates/collection.liquid, 28/09/2026). Cada clique no
     botao (ou na caixa "Vendedor") toca a proxima fala de data-vendedor-falas,
     em ciclo, mesmo com o som do HUD desligado: o clique ja e o pedido, e o
     gesto libera o audio. A caixa escreve a fala letra a letra no ritmo do
     audio: FALAS diz em que segundo do mp3 cada trecho e dito (medido no
     envelope de volume e na transcricao local dos mp3 de midia-ps2/vozes,
     28/09/2026; o riso do comeco de "bem-vindo" e do fim de "coisas-raras" e
     "volte-sempre" nao vira texto). O relogio e o proprio audio.currentTime;
     se o audio falhar ou nao comecar em 1,5 s, escreve pelo relogio da pagina.
     O intervalo de 40 ms so existe enquanto escreve. Se as falas forem
     regravadas (_subir-vozes-ps2.js), medir de novo os tempos daqui. */
  var FALAS = {
    "bem-vindo": [["Bem-vindo, ", 2.25, 3.8], ["foras", 3.85, 4.35], ["teiro.", 4.5, 5.35]],
    "o-que-vai-ser": [["O que vai levar?", 0.1, 2.0]],
    "coisas-raras": [["Tenho umas ", 0.05, 0.95], ["peças ", 1.0, 1.75], ["raras ", 1.8, 2.65], ["aqui.", 2.75, 3.35]],
    "boa-escolha": [["Boa ", 0.05, 1.1], ["escolha, ", 1.15, 2.0], ["foras", 2.05, 2.45], ["teiro.", 2.6, 3.45]],
    "volte-sempre": [["Volte ", 0.05, 1.2], ["sempre.", 1.25, 2.2]],
    "mais-alguma-coisa": [["Mais alguma ", 0.05, 1.2], ["coisa?", 1.3, 2.35]]
  };
  function letrasAte(partes, t) {
    var n = 0;
    for (var i = 0; i < partes.length; i++) {
      var p = partes[i];
      if (t >= p[2]) { n += p[0].length; continue; }
      if (t > p[1]) n += Math.floor(p[0].length * (t - p[1]) / (p[2] - p[1]));
      break;
    }
    return n;
  }
  $$("[data-vendedor]").forEach(function (vend) {
    var botao = $("[data-vendedor-falar]", vend);
    var caixa = $("[data-vendedor-caixa]", vend);
    var texto = $("[data-vendedor-texto]", vend);
    var anuncio = $("[data-vendedor-anuncio]", vend);
    var lista = (vend.getAttribute("data-vendedor-falas") || "").split(/\s+/).filter(function (n) { return FALAS[n]; });
    if (!botao || !texto || !lista.length || !SK8.voz) return;
    var proxima = 0, relogio = null, audio = null, desligar = null, vez = 0;
    var dito = document.createElement("span"), falta = document.createElement("span"), mais = document.createElement("i");
    falta.className = "falta";
    mais.className = "colecao-vendedor-mais";

    // baixa a primeira fala quando a pessoa mostra intencao (mouse em cima,
    // toque ou foco), e a seguinte logo depois de cada clique
    function preparar() { if (SK8.prepararVozes) SK8.prepararVozes([lista[proxima % lista.length]]); }
    ["pointerenter", "touchstart", "focus"].forEach(function (ev) { botao.addEventListener(ev, preparar, { once: true, passive: true }); });
    // e a primeira fala (18 KB) quando a pagina ja carregou e o navegador esta
    // livre: sem isso o primeiro clique esperava ate 1 s pelo mp3
    function prepararOcioso() { if (window.requestIdleCallback) window.requestIdleCallback(preparar, { timeout: 4000 }); else setTimeout(preparar, 1200); }
    if (document.readyState === "complete") prepararOcioso();
    else window.addEventListener("load", prepararOcioso, { once: true });

    function parar() {
      if (relogio) { clearInterval(relogio); relogio = null; }
      if (desligar) { desligar(); desligar = null; }
      vend.classList.remove("falando", "terminou");
    }

    function falar() {
      parar();
      var minhaVez = ++vez;
      var nome = lista[proxima % lista.length];
      proxima++;
      var partes = FALAS[nome];
      var frase = partes.map(function (p) { return p[0]; }).join("").replace(/\s+$/, "");
      var fim = partes[partes.length - 1][2];
      vend.classList.add("falou", "falando");
      dito.textContent = ""; falta.textContent = frase;
      if (texto.firstChild !== dito || texto.childNodes.length !== 3) { texto.textContent = ""; texto.appendChild(dito); texto.appendChild(falta); texto.appendChild(mais); }
      if (anuncio) anuncio.textContent = "Vendedor: " + frase;

      audio = SK8.voz(nome, true, true);
      var inicio = performance.now(), peloRelogio = !audio, escrito = 0, acabouAudio = false;
      if (audio) {
        var aoFalhar = function () { if (!peloRelogio) { peloRelogio = true; inicio = performance.now(); } };
        // "pause" sem "ended": outra fala do site interrompeu esta; a caixa completa a frase
        var aoAcabar = function () { acabouAudio = true; vend.classList.remove("falando"); };
        audio.addEventListener("error", aoFalhar);
        audio.addEventListener("ended", aoAcabar);
        audio.addEventListener("pause", aoAcabar);
        var esse = audio;
        desligar = function () {
          esse.removeEventListener("error", aoFalhar);
          esse.removeEventListener("ended", aoAcabar);
          esse.removeEventListener("pause", aoAcabar);
        };
      }
      function passo() {
        var t, tocando = audio && !audio.paused && audio.currentTime > 0;
        if (acabouAudio) t = fim;
        else if (tocando) t = audio.currentTime;
        else if (peloRelogio) t = (performance.now() - inicio) / 1000;
        else {
          t = 0;
          // o audio nao comecou (rede lenta ou o navegador recusou): segue no
          // relogio; se ele comecar depois, volta a mandar, sem apagar letra
          if (performance.now() - inicio > 1500) { peloRelogio = true; inicio = performance.now(); }
        }
        var n = Math.max(escrito, Math.min(frase.length, letrasAte(partes, t)));
        if (n !== escrito) {
          escrito = n;
          dito.textContent = frase.slice(0, n);
          falta.textContent = frase.slice(n);
        }
        if (n >= frase.length) {
          clearInterval(relogio); relogio = null;
          vend.classList.add("terminou");
          // pelo relogio nao ha "ended": a tremida para logo depois da ultima letra
          if (peloRelogio || acabouAudio) setTimeout(function () { if (minhaVez === vez) vend.classList.remove("falando"); }, 300);
        }
      }
      relogio = setInterval(passo, 40);
      passo();
      preparar();
    }
    botao.addEventListener("click", falar);
    // a caixa de dialogo tambem avanca a fala, como no jogo (so ponteiro: no
    // teclado e no leitor de tela o botao ja faz isso)
    if (caixa) caixa.addEventListener("click", function () { botao.click(); });
  });

  var slots = $$(".slot");
  if (!slots.length) return;
  var info = $(".info-item");
  function mostrar(s) {
    slots.forEach(function (o) { o.classList.toggle("ativo", o === s); });
    if (!info) return;
    $(".nome", info).textContent = s.getAttribute("data-nome");
    $(".linha", info).textContent = s.getAttribute("data-linha");
    $(".preco", info).textContent = s.getAttribute("data-preco");
  }
  slots.forEach(function (s) {
    s.addEventListener("mouseenter", function () { mostrar(s); });
    s.addEventListener("focus", function () { mostrar(s); });
    s.addEventListener("mousemove", function (e) {
      var r = s.getBoundingClientRect();
      s.style.setProperty("--giro", (((e.clientX - r.left) / r.width - 0.5) * 22).toFixed(1) + "deg");
      s.style.setProperty("--incl", ((0.5 - (e.clientY - r.top) / r.height) * 16).toFixed(1) + "deg");
    });
    s.addEventListener("mouseleave", function () { s.style.removeProperty("--giro"); s.style.removeProperty("--incl"); });
  });
  // a foto e de camiseta no chao de cimento; o recorte tira o chao e deita
  // a peca no feltro da maleta. Se o recorte falhar, a foto fica como esta.
  if (!SK8.modulos || !SK8.modulos.recorte || !("IntersectionObserver" in window)) return;
  var fila = [], carregado = null;
  function modulo() { return carregado || (carregado = importar(SK8.modulos.recorte)); }
  var obs = new IntersectionObserver(function (es) {
    es.forEach(function (e) {
      if (!e.isIntersecting) return;
      obs.unobserve(e.target);
      fila.push(e.target);
    });
    processar();
  }, { rootMargin: "300px" });
  var ocupado = false;
  function processar() {
    if (ocupado || !fila.length) return;
    ocupado = true;
    var s = fila.shift(), img = $(".slot-foto img", s);
    var url = img && img.getAttribute("data-recorte");
    if (!url) { ocupado = false; return processar(); }
    modulo().then(function (m) { return m.recortar(url, { largura: 600 }); }).then(function (r) {
      if (r && r.canvas) {
        r.canvas.setAttribute("aria-hidden", "true");
        $(".slot-foto", s).appendChild(r.canvas);
        s.classList.add("recortado");
      }
    }).catch(function () {}).then(function () { ocupado = false; setTimeout(processar, 30); });
  }
  slots.forEach(function (s) { obs.observe(s); });

  window.SK8 = SK8;
})();
